import { render, staticRenderFns } from "./componentCheckbox.vue?vue&type=template&id=2534b066&"
import script from "./componentCheckbox.vue?vue&type=script&lang=ts&"
export * from "./componentCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports